<template>
  <div class="w-10/12 mx-auto pt-10" :class="{ 'iframe-mode': isInIframe }">
    <div :class="primaryTextClass" class="text-zt-xl">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div class="flex justify-between">
            <button class="h-8 w-8 back-button" @click="goBack()" v-on="on">
              <zt-icon name="arrow-left" class="pb-2 mt-1 pr-1" :class="primaryTextClass" />
            </button>
            <zt-button v-if="isApprover && hasVPI" icon="plus-circle" class="text-base"
              @click="$router.push({ name: 'loadTeamLicence' })" data-vs-button="toLoadLicence">{{
                $t("message.LicensesHistoryComponent.tabs.licensesForApproval.loadLicences") }}</zt-button>
          </div>
        </template>
        <span>{{ $t("message.LicensesManager.goBack") }}</span>
      </v-tooltip>
      <span v-show="!fromDashboard" class="ml-1">{{
        $t("message.LicensesHistoryComponent.tabs.licensesForApproval.licensesPending") }}</span>
    </div>
    <div id="pending-table">
      <div class="mt-3">
        <template v-if="showPending === 1">
          <v-toolbar flat color="white" class="elevation-1">
            <div class="inline-flex w-64 mr-4">
              <v-select class="ml-2 pt-1" :items="orderBy" clearable
                :placeholder="$t('message.LicensesManager.orderBy')" item-text="label" item-value="value"
                v-model="columnSelected" @change="orderList()" solo flat data-vs-select="orderBy"></v-select>
              <button class="order-button" @click="pagination.descending = !pagination.descending"
                data-vs-select="toggleOrder">
                <zt-icon :name="pagination.descending ? 'arrow-down' : 'arrow-up'" class="pt-2" :class="primaryTextClass" />
              </button>
            </div>
            <template v-if="selected.length > 0">
              <zt-button @click="openMassive('approve')" icon="check" class="mr-2" data-vs-button="massiveApprove">{{
                $t('message.LincensesApprovalPendingComponent.modal.massiveApprove') }}</zt-button>
              <zt-button @click="openMassive('reject')" data-vs-button="massiveReject" icon="times" color="secondary">{{
                $t('message.LincensesApprovalPendingComponent.modal.massiveReject') }}</zt-button>
            </template>
            <v-spacer></v-spacer>
            <div class="inline-flex w-40 text-zt-lg">
              <zt-button class="mr-2">
                <zt-icon name="list-solid" />
              </zt-button>
              <zt-button outlined @click="showPending = 2" data-vs-button="toCalendar">
                <zt-icon name="calendar-2" />
              </zt-button>
            </div>
          </v-toolbar>
          <v-data-table v-model="selected" :headers="headers" :expand="expand" :items="pendingApprovalLicenses" item-key="id" select-all
            class="elevation-1" :rows-per-page-items="[8, 15, 30]" :pagination.sync="pagination"
            :total-items="pendingLicenses" :loading="loading" :no-data-text="$t('message.datatable.noDataText')">
            <template v-slot:items="props">
              <tr :active="props.selected">
                <td>
                  <v-checkbox v-model="props.selected" :color="primaryColor" hide-details
                    data-vs-checkbox="tableSelected"></v-checkbox>
                </td>
                <td class="text-zt-base text-zt-dark-500">
                  <span v-if="props.item.has_upload_document === 't'">
                    <zt-icon :name="uploadDocumentState(props.item.license_has_document)" class="text-zt-lg"
                      v-bind:class="{ [documentIconColorClass]: props.item.license_has_document === 't' }" />
                  </span>
                  <span v-else class="text-zt-lg pl-1">-</span>
                </td>

                <td class="text-zt-base text-zt-dark-500">{{ props.item.nombre }} {{ props.item.apellido }}</td>
                <td class="text-zt-base text-zt-dark-500">{{ props.item.tipo_licencia }}</td>
                <td class="text-zt-base text-zt-dark-500">{{ props.item.fecha_desde }}-{{ props.item.fecha_regreso }}
                </td>
                <td class="text-zt-base text-zt-dark-500">{{ props.item.dias }}</td>
                <td class="text-zt-base text-zt-dark-500">{{ props.item.fecha_creacion | woTime }}</td>
                <td class="text-zt-base text-zt-dark-500">{{ props.item.numero_legajo }}</td>
                <td class="text-zt-base text-zt-dark-500">
                  <button class="no-border px-1" @click="openSingle('approve', props.item)">
                    <zt-icon class="text-zt-dark-300 text-zt-md cursor-pointer px-2" name="check" />
                  </button>
                  <button class="no-border px-1" @click="openSingle('reject', props.item)">
                    <zt-icon class="text-zt-dark-300 text-zt-md cursor-pointer px-2" name="times" />
                  </button>
                  <button class="no-border px-1" @click="openSingle('details', props.item)">
                    <zt-icon class="text-zt-dark-300 text-zt-md cursor-pointer px-2" name="eye" />
                  </button>
                    <button v-if="props.item.type_id_vp === '2' && hasVPI" class="no-border px-1" @click="openHolidaysModal(props.item)" data-vs-button="openHolidaysModal">
                      <zt-icon class="text-zt-dark-300 text-zt-md cursor-pointer px-2" name="list-ul" />
                    </button>
                </td>
              </tr>
            </template>
            
          </v-data-table>
        </template>
        <template v-if="showPending === 2">
          <PendingCalendar @change-view="showPending = 1" />
        </template>
      </div>
    </div>
    <!-- Modal -->
    <zt-modal :active="modalActive" @close="modalActive = false" :max-width="(modalIsDetail) ? '80rem' : '40rem'">
      <template slot="modal-header">
        <div class="p-4 text-zt-lg flex">
          <div v-if="state.showViewer" @click="resetShowViewer()" class="cursor-pointer mr-4">
            <zt-icon name="angle-left" />
            <span>{{ $t("message.workflow.goBack") }}</span>
          </div>
          <span class="font-bold">{{ titleModal }}</span>
        </div>
      </template>
      <hr class="w-full" />
      <component :is="componentBodyModal" :request="request" :state="state" @close="modalActive = false"
        @refresh-table="getPendingApproval" @change-modal="openSingleFromDetail" @clean-massive-array="selected = []" />
    </zt-modal>
    <HolidaysByPeriodModal
      :activeModal="activeHolidaysModal"
      :licenceId="selectedItemId"
      @close="activeHolidaysModal = !activeHolidaysModal"
    />
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import SichernPeople from '@/apiClient/SichernIntegration'
import { mapGetters, mapActions, mapState } from 'vuex'
import PendingCalendar from './PendingCalendar'
import Approve from './Approve'
import Reject from './Reject'
import Details from './Details'
import HolidaysByPeriodModal from '../request/HolidaysByPeriodModal.vue'

export default {
  inject: ['state', 'mutations'],
  data() {
    return {
      licenses: Licenses,
      sichernPeople: SichernPeople,
      loading: false,
      showPending: 1,
      pendingLicenses: 0,
      pendingApprovalLicenses: [],
      selected: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.pendingLicenses
      },
      expand: true,
      headers: [
        { text: '', sortable: false, align: 'left', value: '' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.nameLastname2'), align: 'left', sortable: false, value: 'nombre' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.licenseType'), sortable: false, align: 'left', value: 'tipo_licencia' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.startReturn'), sortable: false, align: 'left', value: 'fecha_desde' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.days'), sortable: false, align: 'left', value: 'dias' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.request'), sortable: false, align: 'left', value: 'fecha_creacion' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.fileNumber'), sortable: false, align: 'left', value: 'numero_legajo' },
        { text: this.$t('message.LincensesApprovalPendingComponent.labels.action'), sortable: false, align: 'left', value: '' }
      ],
      modalActive: false,
      modalIsDetail: false,
      titleModal: '',
      componentBodyModal: '',
      request: [],
      columnSelected: '',
      orderBy: [
        {
          value: 'name',
          label: this.$t('message.LicensesManager.search.name')
        },
        {
          value: 'surname',
          label: this.$t('message.LicensesManager.search.surname')
        },
        {
          value: 'employeeCode',
          label: this.$t('message.LicensesManager.search.fileNumber')
        },
        {
          value: 'type',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.licenseType")
        },
        {
          value: 'date',
          label: this.$t('message.LicensesManager.search.requestDate')
        },
        {
          value: 'dateFrom',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.startDate")
        },
        {
          value: 'dateTo',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.return")
        },
        {
          value: 'days',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.days")
        }
      ],
      holidayDetails: {},
      loadingDetails: {},
      activeHolidaysModal: false,
      selectedItemId: ''
    }
  },
  components: {
    PendingCalendar,
    HolidaysByPeriodModal
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser'
    }),
    ...mapState('licenses', ['pendingApproval', 'pendingApprovalPagination']),
    fromDashboard() {
      return this.$route.params.routerGo === 'dashboard'
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    isApprover() {
      return this.$store.state.user.es_aprobador
    },
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    documentIconColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    },
  },
  async created() {
    this.licenses = new Licenses()
    this.sichernPeople = new SichernPeople()
    let idUser = this.getUser.id;
    //this.getPendingApproval()
    this.$route.params.showPendingProp ? this.showPending = this.$route.params.showPendingProp : this.showPending = 1

  },
  watch: {
    pagination: {
      handler() {
        this.getPendingApproval()
      },
      deep: true
    },
    'state.updateData'(newVal, oldVal) {
      if (newVal) {
        this.pagination = {
          descending: true,
          page: 1,
          rowsPerPage: 8,
          sortBy: null,
          totalItems: this.pendingLicenses
        }
        this.getPendingApproval()
      }
    }
  },
  methods: {
    ...mapActions('licenses', ['setPendingApproval']),
    testMethod(licenseId) {
      this.$set(this.loadingDetails, licenseId, true)
      this.sichernPeople.getHolidayDetailsVP(licenseId)
        .then(response => {
          if (response.status === 200) {
            const data = response.data.data
            this.$set(this.holidayDetails, licenseId, data)
          } else {
            this.$delete(this.holidayDetails, licenseId)
          }
        })
        .catch(() => {
          this.$delete(this.holidayDetails, licenseId)
        })
        .finally(() => {
          this.$set(this.loadingDetails, licenseId, false)
        })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.pendingApprovalLicenses.slice()
    },
    async getPendingApproval() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      let idUser = this.getUser.id
      await this.setPendingApproval({ idUser, rowsPerPage, page, sortBy, descending });
      this.pendingLicenses = this.pendingApprovalPagination.total
      this.pendingApprovalLicenses = this.pendingApproval
      this.loading = false
    },
    resetShowViewer() {
      this.mutations.setShowViewer(false)
    },
    openSingle(to, item) {
      this.resetShowViewer()
      switch (to) {
        case 'approve':
          this.modalIsDetail = false
          this.componentBodyModal = Approve
          this.request = [item]
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.approveTitle')
          this.modalActive = !this.modalActive
          break
        case 'reject':
          this.modalIsDetail = false
          this.componentBodyModal = Reject
          this.request = [item]
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.rejectTitle')
          this.modalActive = !this.modalActive
          break
        case 'details':
          this.modalIsDetail = true
          this.componentBodyModal = Details
          this.request = item
          this.titleModal = `${this.$t('message.LincensesApprovalPendingComponent.header.title')} - ${item.nombre} ${item.apellido}`
          this.modalActive = !this.modalActive
          break
        default:
          break
      }
    },
    openMassive(to) {
      this.resetShowViewer()
      switch (to) {
        case 'approve':
          this.modalIsDetail = false
          this.componentBodyModal = Approve
          this.request = this.selected
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.massiveApprove')
          this.modalActive = !this.modalActive
          break
        case 'reject':
          this.modalIsDetail = false
          this.componentBodyModal = Reject
          this.request = this.selected
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.massiveReject')
          this.modalActive = !this.modalActive
          break
        default:
          break
      }
    },
    openSingleFromDetail(value) {
      this.openSingle(value.action, value.request)
    },
    orderList() {
      this.pagination.sortBy = this.columnSelected
    },
    uploadDocumentState(hasLoaded) {
      if (hasLoaded !== 't') {
        return 'file-quest'
      }
      return 'file-check'
    },
    openHolidaysModal(item) {
      this.selectedItemId = item.id
      this.activeHolidaysModal = !this.activeHolidaysModal
    },
    goBack() {
      const routerGo = this.$route.params.routerGo;
      const routes = {
        manager: '/manager-licenses-page',
        dashboard: '/dashboard',
        default: '/licenses-manager'
      };
      const route = routes[routerGo] || routes.default;
      this.$router.push(route);
    },
  },
  filters: {
    woTime: value => {
      return value.split(" ")[0]
    }
  },

}
</script>

<style lang="scss" scoped>
::v-deep .zt-modal {
  max-width: inherit !important;
  overflow: auto !important;
}

hr {
  color: #969696;
}

.zt-icon:hover {
  color: #4f41a3;
}

.iframe-mode .zt-icon:hover {
  color: #2694fc;
}

.text-iframe-primary {
  color: #2694fc !important;
}

.back-button:hover {
  background-color: #E0E0E0;
  border-radius: 9999px;
}

.order-button {
  outline: none;
}

.no-border:focus {
  outline: 0;
}

::v-deep table.v-table {
  thead th,
  tbody td {
    padding: 0 16px;
  }

  thead th:first-child,
  tbody td:first-child {
    padding: 0 14px;
  }

  thead th:nth-child(2),
  tbody td:nth-child(2) {
    padding: 0;
  }
}

.iframe-mode {
  ::v-deep .v-datatable__actions {
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}
</style>
